import { Box, Button, ColumnLayout, Container, Header, Link, SpaceBetween } from '@cloudscape-design/components'
import React from 'react'
import { useParams } from 'react-router-dom';
import imageT from "../data/logoipsum-330.svg"


// Summary component (belum responsive)

const DetailOverview = () => {
  
  return (
    <Container
        
          
          
          fitHeight={true}
        >
          <ColumnLayout columns={1} variant="text-grid" minColumnWidth={120}>
            
            <div style={{ textAlign: 'center',marginTop : '30px' }}>
              <Box variant="awsui-key-label"></Box>
            <img src={imageT} alt="/" style={{ width: '200px', height: '200px' }}/>
              
              
             
              </div> 
              
        
                 
                 
                 
               
           
            
           
          </ColumnLayout>
        </Container>
  )
}

export default DetailOverview
